import React, { useState } from "react";
import Layout from "../../component/Layout";
import { Header } from "../../component/Header";
import speedstep2 from "../../images/speedstep2.png";
import strength1 from "../../images/strength1.png";
import strength2 from "../../images/strength2.png";
import strengthLarge from "../../images/strengthLarge.png";
import playIcon from "../../images/playIcon.svg";

const Strength = () => {
  const [selectedItem, setSelectedItem] = useState<
    (typeof strengthData)[0] | null
  >(null);
  return (
    <Layout>
      <div className="bg-white">
        <Header />
      </div>
      <div className="pb-3 pt-2 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL />
        <p className="text-black text-xl font-normal">Monday, Nov 6</p>
        <ArrowG />
      </div>
      <div className="h-full">
        {selectedItem ? (
          // Detail view
          <>
            <div className="h-full w-full max-w-2xl mx-auto ">
              <div className="relative h-[210px]">
                <div className="absolute top-5 left-5">
                  <button
                    className="text-white text-lg"
                    onClick={() => setSelectedItem(null)} // Return to the list view
                  >
                    <ArrowWhite />
                  </button>
                </div>
                <img
                  src={strengthLarge}
                  alt={selectedItem.name}
                  className="h-full w-full object-cover"
                />
                <img
                  src={playIcon}
                  alt="icon"
                  className="object-contain absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 cursor-pointer"
                />
                <div className="absolute bottom-8 left-5">
                  <p className="text-white text-xl font-normal uppercase">
                    {selectedItem.name}
                  </p>
                </div>
              </div>
              <div className="bg-black rounded-t-[20px] relative z-10 -mt-5 pt-5 px-5">
                <div>
                  <p className="text-white text-sm font-normal">
                    Lorem ipsum dolor sit amet consectetur. Cras sit eget velit
                    tristique dictum justo. Cras mi odio id et maecenas nisl
                    odio vitae commodo.
                  </p>
                </div>
                <div className="py-5 mt-5 flex flex-col gap-[10px] border-y border-white/20">
                  <div className="flex justify-between gap-3">
                    <p className="text-white text-sm font-normal">SET 1</p>
                    <p className="text-white text-sm font-normal">
                      12 x 160 lbs
                    </p>
                  </div>
                  <div className="flex justify-between gap-3">
                    <p className="text-white text-sm font-normal">SET 2</p>
                    <p className="text-white text-sm font-normal">
                      12 x 160 lbs
                    </p>
                  </div>
                  <div className="flex justify-between gap-3">
                    <p className="text-white text-sm font-normal">SET 3</p>
                    <p className="text-white text-sm font-normal">
                      12 x 160 lbs
                    </p>
                  </div>
                  <div className="flex justify-between gap-3">
                    <p className="text-white text-sm font-normal">SET 4</p>
                    <p className="text-white text-sm font-normal">
                      12 x 160 lbs
                    </p>
                  </div>
                </div>
                <div className="py-5 border-b border-white/20">
                  <p className="text-white text-sm font-normal">
                    {selectedItem.detail1}
                  </p>
                </div>
                <div className="py-5">
                  <p className="text-white text-sm font-normal">
                    {selectedItem.detail2}
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          // List view
          <div className="bg-white h-full">
            <div className="w-full max-w-2xl mx-auto pt-1 px-5">
              {strengthData.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-row justify-between items-center gap-5 py-[15px] border-b border-black/10 cursor-pointer"
                  onClick={() => setSelectedItem(item)} // Show the detail view
                >
                  <div className="flex flex-col gap-[6px] w-[80%]">
                    <p className="text-black text-base font-normal leading-none">
                      {item.name}
                    </p>
                    <p className="text-black text-base font-light leading-none">
                      {item.detail1}
                    </p>
                    <p className="text-black text-base font-light leading-none">
                      {item.detail2}
                    </p>
                  </div>
                  <div className="w-[38px] h-[38px] rounded-[5px] overflow-hidden">
                    <img src={item.path} alt="img" className="object-contain" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Strength;
const ArrowL = () => {
  return (
    <svg
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ArrowG = () => {
  return (
    <svg
      className="hover:opacity-50  cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ArrowWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#FFFEFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const strengthData = [
  {
    id: 1,
    name: "Box Squat",
    detail1: "4 sets x 8 reps, go up with every set",
    detail2: "60s rest between sets",
    path: strength1,
  },
  {
    id: 2,
    name: "Machine Leg Press",
    detail1: "4 sets x 8 reps, go up with every set",
    detail2: "60s rest between sets",
    path: strength2,
  },
  {
    id: 3,
    name: "Dumbbell Rear Foot Elevated Split Squat",
    detail1: "4 sets x 8 reps, go up with every set",
    detail2: "60s rest between sets",
    path: strength1,
  },
  {
    id: 4,
    name: "Leg Press Machine Calf Raise",
    detail1: "4 sets x 8 reps, go up with every set",
    detail2: "60s rest between sets",
    path: strength2,
  },
  {
    id: 5,
    name: "Box Squat",
    detail1: "4 sets x 8 reps, go up with every set",
    detail2: "60s rest between sets",
    path: strength1,
  },
];
